import { Device } from "../components/Devices/Device";

export const isDeviceLocationAvailable = (device: Device) => {
  const { lat, lng } = device;

  return lat !== undefined && lat !== null && lng !== undefined && lng !== null;
};
